import "core-js/modules/es6.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Configuration } from "../Shared/Configuration";
import { Ajax } from "./Ajax";
export var LookupApiService = /*#__PURE__*/function () {
  function LookupApiService() {
    _classCallCheck(this, LookupApiService);

    var config = new Configuration();
    this._appRoot = config.GetAppRoot();
  }

  _createClass(LookupApiService, [{
    key: "GetCongregations",
    value: function GetCongregations(showAll) {
      var url = "".concat(this._appRoot, "/Api/LookupApi/Congregations");

      if (showAll === true) {
        url += "?onlineOnly=false";
      }

      return Ajax.Get(url);
    }
  }, {
    key: "GetCountries",
    value: function GetCountries() {
      var url = "".concat(this._appRoot, "/Api/LookupApi/Countries");
      return Ajax.Get(url);
    }
  }, {
    key: "GetGenders",
    value: function GetGenders() {
      var url = "".concat(this._appRoot, "/Api/LookupApi/Genders");
      return Ajax.Get(url);
    }
  }, {
    key: "GetMaritalStatuses",
    value: function GetMaritalStatuses() {
      var url = "".concat(this._appRoot, "/Api/LookupApi/MaritalStatuses");
      return Ajax.Get(url);
    }
  }, {
    key: "GetHouseholdPositions",
    value: function GetHouseholdPositions() {
      var url = "".concat(this._appRoot, "/Api/LookupApi/HouseholdPositions");
      return Ajax.Get(url);
    }
  }, {
    key: "GetSuffixes",
    value: function GetSuffixes() {
      var url = "".concat(this._appRoot, "/Api/LookupApi/Suffixes");
      return Ajax.Get(url);
    }
  }, {
    key: "GetPrefixes",
    value: function GetPrefixes() {
      var url = "".concat(this._appRoot, "/Api/LookupApi/Prefixes");
      return Ajax.Get(url);
    }
  }, {
    key: "GetFrequency",
    value: function GetFrequency() {
      var url = "".concat(this._appRoot, "/Api/LookupApi/Frequency");
      return Ajax.Get(url);
    }
  }]);

  return LookupApiService;
}();